<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import BrettAllenMyersImage from './images/Executive_Staff-8x10-BRETT.jpg';
	import MatImage from './images/Executive_Staff-8x10-MAT.jpg';
	import RhettImage from './images/Executive_Staff-8x10-RHETT.jpg';
	import SamImage from './images/Executive_Staff-8x10-SAM.jpg';
	import ShalenImage from './images/Executive_Staff-8x10-SHALEN.jpg';
	import ShawnImage from './images/Executive_Staff-8x10-SHAWN.jpg';
	import StuartImage from './images/Executive_Staff-8x10-STUART.jpg';
</script>

<Section backgroundColor="white">
	<p>
		Indow is made of creative, ambitious, energy-conscience, fun-loving
		innovators. We are collaborators who are always thinking of the next way to
		connect with you and use technology to make our living environment more
		comfortable and efficient.
	</p>
	<p>
		Our leadership team uses Certified Lean practices to help run things as
		efficiently as possible. They prioritize and model inclusion in their
		day-to-day practices, including encouraging collaboration. This was echoed
		in our diversity, equity, and inclusion survey where team members most
		strongly agreed that Indow managers are inclusive, open to new ideas, and
		allow flexibility for different availabilities or abilities.
	</p>
	<p>
		We believe that by encouraging diversity, equity, and inclusion, we will
		access more expansive and varied ideas. That’s why two of our management
		team members sit on our DEI committee.
	</p>
	<p>
		See them in action in these videos: <a
			href="https://www.youtube.com/watch?v=eoQ3UL96zwE"
			target="_blank"
			rel="noreferrer">What You Need to Know Before You Buy</a
		>
		&
		<a
			href="https://www.youtube.com/watch?v=u2ILNHzT8FM"
			target="_blank"
			rel="noreferrer">Soundproofing Windows</a
		>.
	</p>
	<p>Together our leadership team:</p>
	<p>
		Have 6 Degrees<br />
		Started 5 companies<br />
		Have 145 years of experience<br />
		Renovated 10 historic homes (1 on the Historic Register!)<br />
		& Bike 65 miles/week
	</p>
</Section>

<Section backgroundColor="white">
	<Image src={SamImage} alt="Sam Pardue, CEO and Founder" />
	<h2 class="text-indow-blue">Sam Pardue</h2>
	<h3>CEO & Founder</h3>
	<p>
		Sam is the CEO and founder of Indow, which he started in his living room in
		2010. He invented the product himself with a fellow Indow pioneer employee.
		Sam ran product development, marketing, and funding as Indow established
		itself, and remains an active collaborator in each department.
	</p>
	<p>
		Before Indow, Sam co-founded Lensbaby, manufacturer of award-winning special
		effects SLR camera lenses. As Lensbaby’s CEO, Sam drove the branding,
		marketing, and established the global distribution network. Sam’s MBA from
		Carnegie Mellon and years as Marketing Manager at Intel help drive his
		innovative spirit.
	</p>
	<p>
		Sam <a
			href="https://www.linkedin.com/pulse/centering-dei-indow-culture-sam-pardue/"
			target="_blank"
			rel="noreferrer">sits on the DEI committee</a
		> with other team members to help oversee our diversity, equity, and inclusion
		practices
	</p>
	<p>
		<strong>Sustainability Superpower</strong>: As the Planter, Sam provides
		stable conditions for his projects to thrive, and nurtures them to their
		fullest potential.
	</p>
	<p>
		<a
			href="https://www.linkedin.com/in/sampardue/"
			target="_blank"
			rel="noreferrer">LinkedIn</a
		>
	</p>
</Section>

<Section backgroundColor="white">
	<Image src={BrettAllenMyersImage} alt="Brett Myers, Director of Marketing" />
	<h2 class="text-indow-blue">Brett Myers</h2>
	<h3>VP of Customer Journey</h3>
	<p>
		Brett Myers brings 15 years of marketing experience to the Indow team,
		having built and scaled marketing teams across multiple industries (and
		countries), guiding businesses through rapid expansion, and delivering
		upwards of 40% revenue growth. He has thrived in both agency and in-house
		environments, helping brands like ZoomCare, Oregon State University, Enjoy
		Life Foods, and a myriad of other businesses tap into growth opportunities
		while maximizing the impact of their ad spend.
	</p>
	<p>
		Brett joins Indow with the goals of helping the team scale for the future,
		strengthening the brand, and elevating their marketing with cutting edge
		technology, data-driven insights, and market-defining product positioning.
		He also brings internal communications and employee engagement experience to
		the team to help build a better business as part of the DEI committee and
		more.
	</p>
	<p>
		<strong>Sustainability Superpower</strong>: Like Storm from the X-Men, Brett
		controls the weather to bring much needed rain to drought-stricken areas and
		fire-prone forests, while minimizing the damage from increasingly
		devastating natural disasters driven by climate change.
	</p>
	<p>
		<a
			href="https://www.linkedin.com/in/brett-allen-myers"
			target="_blank"
			rel="noreferrer">LinkedIn</a
		>
	</p>
</Section>

<Section backgroundColor="white">
	<Image src={MatImage} alt="Mat Vuksinich, Indow Lead Developer" />
	<h2 class="text-indow-blue">Mat Vuksinich</h2>
	<h3>Lead Developer</h3>
	<p>
		Based in Portland, Oregon, Mat has been overseeing the development and
		optimization of Indow's software systems since 2015, blending innovative
		design with practical functionality to ensure a seamless and effective user
		experience.
	</p>
</Section>

<Section backgroundColor="white">
	<Image src={RhettImage} alt="Ryan Libby, Director of Sales" />
	<h2 class="text-indow-blue">Rhett Wells</h2>
	<h3>Production Supervisor</h3>
	<p>
		Rhett oversees the production of Indow’s core line production, maintaining
		high standards for the inserts as they’re constructed, inspected for
		quality, and packaged and shipped to our customers. Rhett brings over 25
		years of experience in production management at Molded Fiberglass, Pendleton
		Woolen Mills, and Hydro, and has led successful teams of 16 to 120
		individuals. Notably, he led Hydro’s safety record of zero recordable injury
		incidents for three years while managing a team of 120.
	</p>
	<p>
		Outside of Indow, Rhett enjoys riding motorcycles and mountain bikes in the
		Columbia Gorge.
	</p>
	<p>
		<strong>Sustainability Superpower</strong>: Rhett keeps an eye on history to
		learn from the past and work towards a better future.
	</p>
</Section>

<Section backgroundColor="white">
	<Image
		src={ShalenImage}
		alt="Shalen Parker,  Customer Service & Engagement Manager"
	/>
	<h2 class="text-indow-blue">Shalen Parker</h2>
	<h3>Customer Service & Engagement Manager</h3>
	<p>
		Shalen leads the Customer Service & Engagement team, who expertly handle
		customer communications along multiple channels to inform, update, and
		connect customers with answers and solutions about Indow products and
		processes. He holds a B.A. in both Film and English from the University of
		Oregon.
	</p>
	<p>
		Outside of Indow, Shalen is an active songwriter and musician, a father of
		two grown children, and a lover of nearly all things outdoors.
	</p>
	<p>
		<strong>Sustainability Superpower</strong>: Shalen hates unnecessary plastic
		packaging. He actively seeks out products and services that utilize
		recyclable and reusable materials, especially in food products. This may not
		be a superpower, but it does require decisive, deliberate, and diligent
		daily action. He has also found it helps to build a stocked pantry and leads
		to better (and more frequent) home cooking.
	</p>
</Section>

<Section backgroundColor="white">
	<Image src={ShawnImage} alt="Shawn Schueller, Indow Controller" />
	<h2 class="text-indow-blue">Shawn Schueller</h2>
	<h3>Controller</h3>
	<p>
		Shawn leads the Finance and Operations teams at Indow. Since joining the
		team in 2015, Shawn has been a key contributor to major projects such as
		streamlining sales tax compliance, inventory management, and budgeting.
		Prior to Indow Shawn spent 11 years at CaptionMax, serving in both a Finance
		and HR capacity.
	</p>
	<p>
		<strong>Sustainability Superpower</strong>: Shawn’s innovative spirit helps
		him review any problem and develop a feasible solution. Rumor has it that
		this is how Shawn invented the wheel, the telephone, and the sun.
	</p>
</Section>

<Section backgroundColor="white">
	<Image src={StuartImage} alt="Stuart Rosenfeld, Indow VP of Finance" />
	<h2 class="text-indow-blue">Stuart Rosenfeld</h2>
	<h3>VP of Finance</h3>
	<p>
		One of the original members of the Indow team, Stuart brings over 20 years
		experience in finance, accounting, and operations in both corporate and
		start-up environments. Stuart has a background in systems, and has managed
		financial system conversions and upgrades for firms during rapid growth
		phases. He has worked with Sequent Computer Systems, Photon Kinetics,
		Chevron Corporation, and Daverci Solutions. He served as the Director of
		Finance and Administration for Ecotrust, an Oregon conservation-based
		economic development organization; and founded Zig Zag Wireless, a wireless
		Internet service provider for multi-dwelling units. Stuart holds a BA in
		Finance from the University of Washington.
	</p>
	<p>
		<strong>Sustainability Superpower</strong>: Stuart can predict the weather
		with uncanny accuracy.
	</p>
	<p>
		<a
			href="https://www.linkedin.com/in/stuart-rosenfeld-a8991a/"
			target="_blank"
			rel="noreferrer">LinkedIn</a
		>
	</p>
</Section>
